import logger from './logger';

// `window.axios` is the authenticated instance set up in
// `entrypoints/dashboard.js` via `createAxios` (carries devise-token-auth headers).
const http = () => window.axios;

const accountBase = accountId => `/api/v1/accounts/${accountId}/translations`;

export const translateInboundMessages = async ({
  accountId,
  messageIds,
  sourceLang = 'auto',
  targetLang,
  direction = 'in',
}) => {
  const t0 = Date.now();
  try {
    // Bubble path: host ignores client source_lang and forces auto-detect;
    // still send 'auto' so logs/proxies stay explicit.
    const { data } = await http().post(`${accountBase(accountId)}/messages`, {
      message_ids: messageIds,
      source_lang: sourceLang || 'auto',
      target_lang: targetLang,
      direction,
    });
    logger.info('messages.success', {
      direction,
      sourceLang: sourceLang || 'auto',
      targetLang,
      count: messageIds.length,
      durationMs: Date.now() - t0,
    });
    return data;
  } catch (err) {
    logger.error('messages.error', {
      direction,
      count: messageIds.length,
      status: err?.response?.status,
    });
    throw err;
  }
};

export const translateOutboundDraft = async ({
  accountId,
  conversationId,
  text,
  targetLang,
}) => {
  const t0 = Date.now();
  try {
    const { data } = await http().post(`${accountBase(accountId)}/outbound`, {
      conversation_id: conversationId,
      text,
      target_lang: targetLang,
    });
    logger.info('outbound.success', { durationMs: Date.now() - t0 });
    return data;
  } catch (err) {
    logger.error('outbound.error', { status: err?.response?.status });
    throw err;
  }
};

export const fetchUsage = async ({
  accountId,
  from,
  to,
  userIds = [],
  granularity = 'day',
}) => {
  const { data } = await http().get(`${accountBase(accountId)}/usage`, {
    params: { from, to, user_ids: userIds, granularity },
  });
  return data;
};
